import coreAPIInstance from "./coreApiInstance";

export const coreFieldAPIs = {
  getCoreFields: ({ payload, headers }) => coreAPIInstance.post(`/api/v1/fields/get`, payload, { headers }),
  createCoreField: ({ payload, headers }) => coreAPIInstance.post(`/api/v1/fields/create`, payload, { headers }),
  updateCoreField: ({ payload, headers }) => coreAPIInstance.post(`/api/v1/fields/update`, payload, { headers }),
};
